import {AccessResolver} from "./check.resolver";
import {CommandeFormationResolver} from "./commande-formation.resolver";
import {RecapCommandeComponent} from "./pages/commande/recap-commande/recap-commande.component";
import {NotificationNumberResolver} from "./notification.resolver";
import {DocumentsComplementairesResolver} from "./pages/commande/documents-complementaires.resolver";
import {ICommandeFormationWebServiceClient, IFormationWebServiceClient} from "@resources/resources";
import {EnregistrementFormationComponent} from "./pages/administration/formation/enregistrement/enregistrement.formation.component";
import {AdminFormationComponent} from "./pages/administration/formation/admin.formation.component";
import {AdministrationPageComponent} from "./pages/administration/administration.component";
import {FormationsAdminResolver} from "./pages/administration/formation/admin.formation.resolver";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {LogoutAuthGuard} from "@digicerba/common";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {UserGuardAndResolve} from "./user.guard";
import {EnregistrementFormationResolver} from "app/pages/cerba/pages/administration/formation/enregistrement/enregistrement.formation.resolver";
import {ResourceMultimediaPipe} from "app/common/utils/image/resource.multimedia.pipe";
import {FormationsResolver} from "app/pages/cerba/pages/commande/formation.resolver";
import {InscriptionComponent} from "./pages/commande/inscription/inscription.component";
import {CatalogueFormationComponent} from "./pages/commande/catalogue-formation.component";
import {RecapInscriptionComponent} from "./pages/commande/recap-inscription/recap-inscription.component";
import {ModalDialog} from "@common/utils/dialog/modal/modal.component";
import {FormationsAdminGuard} from "./formations-admin-guard";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [UserGuardAndResolve],
    resolve: {
      nbAlerts: NotificationNumberResolver,
    },
    children: [
      {
        path: 'liste-formations', component: CatalogueFormationComponent,
        resolve: {
          formations: FormationsResolver,
          documentsComplementaires: DocumentsComplementairesResolver,
          commandeDeleted: CommandeFormationResolver
        }
      },

      {
        path: 'inscription', component: InscriptionComponent,
        resolve: {
          commandeDeleted: CommandeFormationResolver
        }
      },
      {
        path: 'recap-inscription', component: RecapInscriptionComponent,
        resolve: {
          commandeDeleted: CommandeFormationResolver
        }
      },
      {
        path: 'recap-commande', component: RecapCommandeComponent,
      },
      {
        path: 'administration', component: AdministrationPageComponent,
        canActivate: [FormationsAdminGuard],
        children: [
          {
            path: 'formations', component: AdminFormationComponent,
            resolve: {
              formations: FormationsAdminResolver,
            }
          },
          {
            path: 'enregistrement',
            children: [
              { path: 'formation', component: EnregistrementFormationComponent },
              {
                path: 'formation/:id', component: EnregistrementFormationComponent,
                resolve: {
                  formation: EnregistrementFormationResolver,
                }
              }
            ]
          },
          { path: '', redirectTo: 'formations', pathMatch: 'full' },
        ]
      },
      {
        path: '', redirectTo: 'liste-formations', pathMatch: 'full'
      }
    ]
  },
  { path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard] },
  { path: '', redirectTo: 'cerba', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    AdministrationPageComponent,
    AdminFormationComponent,
    EnregistrementFormationComponent,
    CatalogueFormationComponent,
    InscriptionComponent,
    RecapInscriptionComponent,
    RecapCommandeComponent,
    ModalDialog
  ],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, { useHash: true }),
  ],
  exports: [
    RouterModule
  ],
  entryComponents: [ModalDialog],
  providers: [
    FormationsAdminResolver, FormationsResolver,
    EnregistrementFormationResolver, IFormationWebServiceClient, ICommandeFormationWebServiceClient, ResourceMultimediaPipe,
    DocumentsComplementairesResolver, UserGuardAndResolve,
    NotificationNumberResolver, CommandeFormationResolver,
    AccessResolver, FormationsAdminGuard
  ]
})
export class CerbaRoutingModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts